import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { TimetableSlotSelectionEvent } from '@dreryk/react-calendar';
import { ModalConfirmButton } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

import { AppointmentCreateModal } from './shared/AppointmentCreateModal';
import { AppointmentCreateActionEventInterceptor } from './interceptors/AppointmentCreateActionEventInterceptor';

type AppointmentBookModalProps = {
   readonly selectedSlot: TimetableSlotSelectionEvent<AppointmentPractitioner>;
   readonly overlappingAppointmentsAllowed: boolean;
   readonly onClose: VoidFunction;
   readonly onSuccess: VoidFunction;
};

export const AppointmentBookModal = (props: AppointmentBookModalProps): JSX.Element | null => {
   return (
      <AppointmentCreateModal
         testId={'appointmentBook'}
         selectedSlot={props.selectedSlot}
         overlappingAppointmentsAllowed={props.overlappingAppointmentsAllowed}
         onClose={props.onClose}
         confirmButton={({ handleSubmit, setAppointmentTimeSlotOccupiedError }) => (
            <AppointmentCreateActionEventInterceptor
               handleSubmit={handleSubmit}
               onAppointmentTimeSlotOccupiedFault={setAppointmentTimeSlotOccupiedError}
            >
               <ModalConfirmButton
                  label={appointmentsTranslationKeys.create.modal.confirm.register}
                  onClick={props.onSuccess}
               />
            </AppointmentCreateActionEventInterceptor>
         )}
      />
   );
};
